import Axios, {AxiosInstance, AxiosResponse, InternalAxiosRequestConfig, AxiosError} from 'axios';
import qs from 'qs';

interface PostFile{
    params:{},
    files:File[]
}
class HttpCommImpl
{
    private instance:AxiosInstance;
    constructor(axioInst:AxiosInstance)
    {
        this.instance = axioInst;
    }

    hookRequest(userFn:(config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig):number
    {
        return this.instance.interceptors.request.use(function(config: InternalAxiosRequestConfig){
                return userFn(config);
            }
        );
    }

    hookResponse(successFn:(response: AxiosResponse) => AxiosResponse, errorFn:(error: AxiosError) => AxiosError):number
    {
        return this.instance.interceptors.response.use(function(response: AxiosResponse){
            return successFn(response);
        }, function(error: AxiosError) {
            return errorFn(error);
        } );
    }

    unhookRequest(interceptorId: number) {
        this.instance.interceptors.request.eject(interceptorId);
    }

    unhookResponse(interceptorId: number) {
        this.instance.interceptors.response.eject(interceptorId);
    }

    getData<M>(url:string, params={}, headers={}):Promise<AxiosResponse<M>>
    {
        return this.instance.get(url, {params:params, headers:headers, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })});
    }

    postData<M>(url:string, data={}, headers={}):Promise<AxiosResponse<M>>
    {
        return this.instance.post(url, data, {headers:headers});
    }

    postFileData<M>(url:string, params={}, headers={}):Promise<AxiosResponse<M>>
    {

        let form = new FormData();
        for(var key in params)
        {
            if(key === "file"){
                let f = Object(params)[key];
                f.map((file: File)=>{
                    form.append("file", file);
                });
            }else{
                form.append(key, Object(params)[key]);
            }

        }
        return this.instance.post(url, form, {headers:headers});
    }

    postFormData<M>(url:string, params={}, headers={}):Promise<AxiosResponse<M>>
    {
        let form = new FormData();
        for(var key in params)
        {
            let val = Object(params)[key];
            if(Array.isArray(val))
            {
                val.map((ele)=>{
                    form.append(key, ele);
                });
            }
            else
            {
                form.append(key, val);
                //form.append(key, Object(params)[key]);
            }
        }
        return this.instance.post(url, form, {headers:headers});
    }

    putData<M>(url:string, data={}, headers={}):Promise<AxiosResponse<M>>
    {
        return this.instance.put(url, data, {headers:headers});
    }

    putFormData<M>(url:string, params={}, headers={}):Promise<AxiosResponse<M>>
    {
        let form = new FormData();
        var obj = Object(params);
        for(var key in params)
        {
            form.append(key, obj[key]);
        }
        return this.instance.put(url, form, {headers:headers});
    }

    deleteData<M>(url:string, params={}, headers={}):Promise<AxiosResponse<M>>
    {
       return this.instance.delete(url, {params:params, headers:headers});
    }

}

export const HttpComm = HttpCommImpl;
